// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFaCkOFfqomEYobcYENtOoO5MVG7jnCjM",
  authDomain: "shape-interior.firebaseapp.com",
  projectId: "shape-interior",
  storageBucket: "shape-interior.firebasestorage.app",
  messagingSenderId: "544694287353",
  appId: "1:544694287353:web:9a561bc217a740b69a1b28",
  measurementId: "G-77RHV1XQBY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
export { app, analytics, db };
